import { ActionType } from "../../../../../../react-core/Flux/ActionType";
import { Dispatcher } from "../../../../../../react-core/Flux/Dispatcher";
import { BuyStoreStatic } from "./BuyStoreStatic";

export interface FluxResponse {
    actionType: ActionType;
    isLoading?: boolean;
    payload?: any;
    otherObj?: any;
}

export const BuyDispatcher: Dispatcher<FluxResponse> = new Dispatcher<FluxResponse>();
export const BuyStore: BuyStoreStatic = new BuyStoreStatic();
